import React from 'react';
import { SimplifiedParsedUploadModal } from './ParsedUploadWizard';

interface ImportModalProps {
  isOpen: boolean;
  onClose: () => void;
  folderId: string;
  folderName: string;
  onComplete: () => Promise<void>;
}

/**
 * ImportModal - Wrapper for the Simplified Parsed Upload Modal
 *
 * Uses a simplified 2-step flow:
 * 1. Drop folder containing markdown/ and assets/
 * 2. Upload and process
 *
 * All documents are uploaded to the target folder directly (no subfolders).
 */
const ImportModal: React.FC<ImportModalProps> = ({ isOpen, onClose, folderId, folderName, onComplete }) => {
  const handleComplete = () => {
    // Trigger a refresh of the document list
    onComplete().catch(console.error);
  };

  return <SimplifiedParsedUploadModal isOpen={isOpen} onClose={onClose} folderId={folderId} folderName={folderName} onComplete={handleComplete} />;
};

export default ImportModal;
